"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSIONS_ERROR = void 0;
var PERMISSIONS_ERROR = 'PERMISSIONS_ERROR';
exports.PERMISSIONS_ERROR = PERMISSIONS_ERROR;